module.exports = __webpack_public_path__ + "img/pos.19b9ae7f.svg";